import React from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import circle from "../../../../assets/DigitalMarketing/image/dashboard/circle_down.svg";

function ChartBox(props) {
  const {element,title} = props;
  return (
    <div className="cards h-100">
      <div className="d-flex justify-content-between">
        <h3 className="f-10 fw-300">{title}</h3>
        <span>
          Today <img src={circle} alt="i" />
        </span>
      </div>
      <div className="d-flex">
            <div className="me-3">        
              <p className="f-12 mb-1">Bindu</p>
              <p>Manage Mensuration Cycle
              Irregular Periods
              PCOD</p>
            </div>
            <div className="me-3">
              <p className="f-12 mb-1">Lakshmi Sree</p>
              <p>Regular Periods
              Duration of Periods
              Ovulation Phase
              Predicting Ovulation
              PMS Symptoms</p>
            </div>
            <div className="me-3">
              <p className="f-12 mb-1">Anandh Jothi</p>
              <p>Fertility Analysis
              Diet Chart</p>
            </div>            
          </div>
      <div>
        {element}
      </div>  
    </div>
  );
}

export default ChartBox;